<template>
  <div class="app-container">
    <iframe class="frame_page"
            ref="mapFrame"
            src="https://lfczhxc.com/gis/App_Html/Page/Index.html">

    </iframe>
    <!-- <iframe class="frame_page"
                ref="mapFrame"
          src="http://117.80.118.137:8888/App_Html/Page/Index.html">

        </iframe> -->
    <!-- src="http://117.80.118.137:8888/App_Html/Page/Index.html"> -->
    <!-- 	<div class="frame_page" ref="mapFrame">
        <img src="../../assets/satistics/map/beijing.png" @click="tupanclic" />
      </div> -->
    <div class="left_pad" v-show="leftshow">
      <info-map futitle="[男女比例]" fxnum="" height="13%">
        <div class="sexbg" style="height: 50%;">
          <img src="../../assets/satistics/map/boy.png"/>
          <ec-pross :data='sexdata' type="男"></ec-pross>
        </div>
        <div class="sexbg" style="height: 50%;">
          <img src="../../assets/satistics/map/girl.png"/>
          <ec-pross :data='sexdata' type="女"></ec-pross>
        </div>
      </info-map>
      <info-map futitle="[民族占比]" fxnum="" height="23%">
        <ec-pie type="大环无lable" style="width: 100%;height: 100%" :data="pieData1" v-if="pieData1"
                :color="pieColors"></ec-pie>
      </info-map>
      <info-map futitle="[网格户数分析]" fxnum="" height="28%">
        <div class="wghsfx">
          <div class="wghsitem" v-for="(item,index) in wghsfxlist" :key="index">
            <div class="wgfxnum">
              <span>{{item.num}}</span>户
            </div>
            <div class="wgfxname">{{item.gridName}}</div>
          </div>
        </div>
      </info-map>
      <info-map futitle="[网格常驻人口分析]" fxnum="" height="30%">
        <ec-barmap style="height: 100%;" :data="renkouData" :names="renkouNames" type="lines" unit="人">
        </ec-barmap>
      </info-map>
      <info-map futitle="[网格党员分析]" fxnum="" height="30%">
        <ec-line style="height: 100%;" :data="dangyuanData" :names="dangyuanNames" type="lines" unit="人"
                 v-if="dangyuanData"></ec-line>
      </info-map>
    </div>
    <div class="tableft" :class="{shouqi:leftshow==false}" @click="leftshow=!leftshow"></div>
    <div class="choosebg" :class="{left:leftshow==false}">
      <el-select v-model="selectValue" multiple @remove-tag="removeLabels" popper-class="mapselect"
                 :popper-append-to-body="false" collapse-tags style="margin-left: 20px;" placeholder="请选择">
        <el-checkbox :style="{paddingLeft:'20px'}" :indeterminate="org.isIndeterminate" v-model="org.checkAll"
                     @change="handleCheckAllChange($event)">
          全选
        </el-checkbox>
        <el-option v-for="(item, index) in options" :key="item.value" :label="item.label" :value="item.value"
                   @click.native="handleSelect(index)">
          <div style="display:inline-block" @click="clickCheckbox">
            <el-checkbox v-model="item.isCheck"></el-checkbox>
          </div>
          <img class="elopimg" :src="require('../../assets/satistics/map/'+item.img)"/>
          <span>{{item.label}}</span>
        </el-option>
      </el-select>
    </div>

    <div class="right_pad" v-show="rightshow">
      <div class="gunbi" @click="rightshow=false"><i class="el-icon-error"></i></div>
      <info-map futitle="[家庭信息]" fxnum="" height="100%" v-show="mapclickType!='5'&mapclickType!='6'">
        <mapxq :data="huzhulist" :datalist='jtlist' :type="mapclickType"></mapxq>
      </info-map>
      <info-map futitle="[企业信息]" fxnum="" height="100%" v-show="mapclickType=='6'">
        <mapxq :data="huzhulist" :datalist='huzhulist' :type="mapclickType"></mapxq>
      </info-map>
      <info-map futitle="[农田信息]" fxnum="" height="100%" v-show="mapclickType=='5'">
        <mapxq :data="huzhulist" :datalist='[]' :type="mapclickType"></mapxq>
      </info-map>

    </div>
    <!-- <div class="back_button" @click="goback">
      <img src="../../assets/satistics/icon-back-to-index.png" alt="" class="map_icon">
    </div> -->
    <div class="celiangbtn">
      <div v-for="(item,index) in clbtn" @click="mapLong(item.index,index)">
        <img :src="require('../../assets/satistics/map/'+item.img)" class="map_icon" v-show="clclickindex!=index">
        <img :src="require('../../assets/satistics/map/'+item.imgblue)" class="map_icon" v-show="clclickindex===index">
      </div>

    </div>
  </div>

</template>

<script>
  import {
    Carousel,
    CarouselItem,
    Select,
    Option,
    Radio,
    Checkbox
  } from 'element-ui'
  import Vue from 'vue'

  Vue.use(Carousel)
  Vue.use(CarouselItem)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Radio)
  Vue.use(Checkbox)
  export default {
    name: "info",
    components: {
      ecPie: () => import('./components/ec-pie'),
      infoMap: () => import('./components/infomap'),
      ecPross: () => import('./components/ec-pross'),
      ecPie: () => import('./components/ec-pie'),
      ecBarmap: () => import('./components/ec-barmap.vue'),
      ecLine: () => import('./components/ec-linemap'),
      mapxq: () => import('./components/mapxq'),

    },
    computed: {},
    data() {
      return {
        thisYear: new Date().getFullYear(),
        clclickindex: -1,
        clbtn: [
          {
            index: 3,
            img: 'map_clgd.png',
            imgblue: 'map_clgdblue.png'
          },
          {
            index: 1,
            img: 'map_clcd.png',
            imgblue: 'map_clcdblue.png'
          },
          {
            index: 2,
            img: 'map_clmj.png',
            imgblue: 'map_clmjblue.png'
          },
          {
            index: 6,
            img: 'map_clgd.png',
            imgblue: 'map_clgdblue.png'
          },
          {
            index: 0,
            img: 'map_qingkong.png',
            imgblue: 'map_qingkongblue.png'
          },
          {
            index: -1,
            img: 'map_shouye.png',
            imgblue: 'map_shouyeblue.png'
          },

        ],
        leftshow: true,
        rightshow: false,
        isiframe: false,
        sexdata: [{
          value: [50, 20],
          name: ["男", "女"]
        }],
        pieData1: [{
          name: 'test1',
          value: 5
        }, {
          name: 'test2',
          value: 6
        }, {
          name: 'test3',
          value: 7
        }, {
          name: 'test4',
          value: 8
        }, {
          name: 'test5',
          value: 9
        }, {
          name: 'test11',
          value: 9
        }, {
          name: 'test6',
          value: 9
        }, {
          name: 'test7',
          value: 9
        }, {
          name: 'test8',
          value: 8
        },],
        pieColors: ['#3994E7', '#31FFC3', '#00BB69', '#FF4A4A', '#FFA22B', '#A95BFF', '#6755FF', '#48FFEB',
          '#FF47B4', '#3994E7', '#31FFC3'
        ],
        wghsfxlist: [{
          num: 22,
          gridName: '网格名称01'
        },
          {
            num: 22,
            gridName: '网格名称01'
          },
          {
            num: 22,
            gridName: '网格名称01'
          },
          {
            num: 22,
            gridName: '网格名称01'
          },
          {
            num: 22,
            gridName: '网格名称01'
          },
          {
            num: 22,
            gridName: '网格名称01'
          }
        ],
        renkouData: [{
          name: '常住人口数量',
          type: 'bar',
          stack: 'Total',
          data: [5, 1, 15, 53, 81, 92]
        }],
        renkouNames: ['网格名称01', '网格名称02', '网格名称03', '网格名称04', '网格名称05', '网格名称06'],
        dangyuanData: [{
          name: '网格党员数量',
          type: 'line',
          stack: 'Total',
          data: [5, 1, 15, 53, 81, 92]
        }],
        dangyuanNames: ['网格名称01', '网格名称02', '网格名称03', '网格名称04', '网格名称05', '网格名称06'],
        isjtshow: 0,
        isclickcq: -1,
        huzhulist: {
          "id": "9db2cebe827d48dc93a8b506c6947d2a",
          "residenceNo": "320500433704619", //房屋户号
          "name": "周学新", //姓名
          "sex": "男", //性别
          "nation": "汉", //民族
          "birthday": "19681009", //出生年月日
          "cardNo": "320524196810094513", //身份证
          "address": null, //户籍地址
          "familyRelation": "户主", //家庭关系
          "isEnjoy": null,
          "contact": null, //联系方式
          "gridName": null,
          "remark": null, //备注
          "longitude": "120.6139581700000036335040931589901447296142578125",
          "latitude": "31.529096110000001118578438763506710529327392578125",
          "groupName": null,
          "peopleType": "1" //1-群众；2-党员
        },
        // qyxqshow: 0,
        // qylist: {},
        // ntxqshow: 0,
        // ntlist: {},
        // isclickntxq: -1,
        // ntlistcard: [],
        // ntlistcardxq: [],
        // jtxqlist: [],
        jtlist: [{
          name: "张文顺",
          guanxi: "父子关系",
          sex: "男",
          mingzu: "汉族",
          csyear: "1987年12月18日"
        },],
        selectValue: ['1', '2', '3', '4', '5', '6'],
        org: {
          isIndeterminate: false,
          checkAll: true,
        },
        options: [{
          value: '1',
          label: '村户',
          isCheck: true,
          img: 'cunhu.png'
        }, {
          value: '2',
          label: '党员户',
          isCheck: true,
          img: 'dangyuanhu.png'
        }, {
          value: '3',
          label: '退伍军人户',
          isCheck: true,
          img: 'twjrhu.png'
        }, {
          value: '4',
          label: '五保户',
          isCheck: true,
          img: 'wubaohu.png'
        }, {
          value: '5',
          label: '农田',
          isCheck: true,
          img: 'nongtian.png'
        }, {
          value: '6',
          label: '企业',
          isCheck: true,
          img: 'qiye.png'
        },],
        mapclickType: "",
        // 选中地图户主
        selectHouseData: [],
        lingfengInfo: {},
      }
    },
    // watch: {
    //   selectOwnerId(newVal, oldValue) {
    //     console.log(newVal, 'new')
    //     console.log(oldValue, 'old')
    //   }
    // },
    mounted() {
      // this.initMapInfo()
      Promise.all([
        // this.initMapInfo(),
        this.getPeopleRate(),
        this.getNationalityRate(),
        this.getGridRate()
      ]).catch(e => console.log(e, 'expcet'))


    },
    created() {
      Promise.all([
        this.initMapInfo(),
      ]).catch(e => console.log(e, 'expcet'))
    },

    beforeDestroy() {
    },
    methods: {
      goback() {
        this.$router.replace('/satisticsSec')
      },
      // checkxq(index, item) {
      // 	// this.isjtshow = 2
      // 	// this.isclickcq = index
      // 	this.jtxqlist = item
      // },
      // checkxqnt(index, item) {
      // 	this.ntxqshow = 2
      // 	this.isclickntxq = index
      // 	this.ntlistcardxq = item
      // },
      tupanclic() {
        let typeindex = 5
        this.mapclickType = typeindex
        if (typeindex == '5') { //农田
          this.queryFamilyDataNT('5ae3b8be29814a4c8d366a768df2c944')
        } else if (typeindex == '6') { //企业
          this.queryFamilyDataQY('1e402ce2797d428fa81a77947fc6f676')
        } else {
          // 获取选中户主信息
          this.queryFamilyData('320586199202074511')
        }
      },

      // 地图打点
      initMapInfo() {
        addEventListener('message', e => {
          // console.log(e)
          let type = Object.prototype.toString.call(e.data);

          if (type === "[object String]") {
            let data = JSON.parse(e.data)
            if (data.hasOwnProperty("type")) {
              let typeindex = parseInt(data.type)
              // typeindex=6
              this.mapclickType = data.type
              if (typeindex < 5) { //农田
                // 获取选中户主信息
                // this.queryFamilyDataNT('5ae3b8be29814a4c8d366a768df2c944')
                this.queryFamilyData(data.result)

              } else if (typeindex == 6) { //企业
                // this.queryFamilyDataQY('1e402ce2797d428fa81a77947fc6f676')
                this.queryFamilyDataQY(data.result)
              } else if (typeindex == 5) { //农田
                // this.queryFamilyDataNT('13f8773ec8304084b409506a63e91bbb')
                this.queryFamilyDataNT(data.result)
              }
            }

          }
          //     if (data.type == 'msg') {
          //       // 获取选中户主信息
          // console.log(data)
          //       this.queryFamilyData(data.result)
          //     }
        })
        // 获取住户信息

        let typeList = this.selectValue.join(',')
        let params = {
          'typeList': this.selectValue,
        }
        this.$http.get('api/gis/pointRate?typeList=' + typeList).then(res => {
          if (res.data.code == 200) {
            // 打点
            let datamap = {
              result: [],
              type: "Add"
            }
            if (res.data.data.hasOwnProperty("peopleList")) {
              res.data.data.peopleList.forEach(item => { //村户
                let obj = {
                  hh: item.residenceNo,
                  hz: item.name,
                  lat: item.latitude,
                  lon: item.longitude,
                  type: "1",
                }

                datamap.result.push(obj)
              })
            }
            if (res.data.data.hasOwnProperty("dangyuanList")) {
              res.data.data.dangyuanList.forEach(item => { //党员
                let obj = {
                  hh: item.residenceNo,
                  hz: item.name,
                  lat: item.latitude,
                  lon: item.longitude,
                  type: "2",
                }

                datamap.result.push(obj)
              })
            }
            if (res.data.data.hasOwnProperty("tuiwuList")) {
              res.data.data.tuiwuList.forEach(item => { //退伍军人
                let obj = {
                  hh: item.residenceNo,
                  hz: item.name,
                  lat: item.latitude,
                  lon: item.longitude,
                  type: "3",
                }
                datamap.result.push(obj)
              })
            }
            if (res.data.data.hasOwnProperty("wubaoList")) {
              res.data.data.wubaoList.forEach(item => { //五保户
                let obj = {
                  hh: item.residenceNo,
                  hz: item.name,
                  lat: item.latitude,
                  lon: item.longitude,
                  type: "4",
                }
                datamap.result.push(obj)
              })
            }
            if (res.data.data.hasOwnProperty("tudiList")) {
              res.data.data.tudiList.forEach(item => { //农田
                let obj = {
                  hh: item.id,
                  hz: item.name,
                  lat: item.latitude,
                  lon: item.longitude,
                  type: "5",
                }
                datamap.result.push(obj)
              })
            }
            if (res.data.data.hasOwnProperty("companyList")) {
              res.data.data.companyList.forEach(item => { //企业
                // console.log(item,11111111111);
                let obj = {
                  hh: item.id,
                  hz: item.name,
                  lat: item.latitude,
                  lon: item.longitude,
                  type: "6",
                  height: '20',
                }
                datamap.result.push(obj)
              })
            }
            if (datamap.result.length == 0) {
              let obj = {
                hh: '',
                hz: '',
                lat: '',
                lon: '',
                type: "1",
              }
              datamap.result.push(obj)
            }
            let that = this
            let mapFrame = this.$refs["mapFrame"]
            that.$refs.mapFrame.contentWindow.postMessage(JSON.stringify(datamap), '*')
            if (mapFrame.attachEvent) { //兼容浏览器判断
              mapFrame.attachEvent("onload", function () {
                that.$refs.mapFrame.contentWindow.postMessage(JSON.stringify(datamap), '*')
                // let iframeWin = mapFrame.contentWindow
                // iframeWin.postMessage(JSON.stringify(datamap),"*")
              })
            } else {

              mapFrame.onload = function () {
                that.$refs.mapFrame.contentWindow.postMessage(JSON.stringify(datamap), '*')
                // let iframeWin = mapFrame.contentWindow
                // iframeWin.postMessage(JSON.stringify(datamap),"*")
              }
            }
          }
        })

        //   this.$http.get('api/gis/initPoint').then(res => {
        //     if (res.data.code == 200) {
        //       // 打点
        //       let posInfo = res.data.data
        // console.log(posInfo)
        //       // this.$refs.mapFrame.contentWindow.postMessage(JSON.stringify(posInfo), '*')
        // let mapFrame = this.$refs["mapFrame"]
        // 	if (mapFrame.attachEvent){  //兼容浏览器判断
        // 			mapFrame.attachEvent("onload", function(){
        // 					let iframeWin = mapFrame.contentWindow
        // 					iframeWin.postMessage(JSON.stringify(posInfo),"*")
        // 			})
        // 	} else {
        // 			mapFrame.onload = function(){
        // 					let iframeWin = mapFrame.contentWindow
        // 					iframeWin.postMessage(JSON.stringify(posInfo),"*")
        // 			}
        // 	}
        //     }
        //   })

      },
      // 地图点击事件,村户，党员，退伍军人，五保户
      queryFamilyData(id) {
        // this.isjtshow = 0
        // this.isclickcq = -1
        this.$http.get(`api/gis/listPeopleByResidenceNo?residenceNo=${id}`).then(res => {
          // console.log(res, 'res')
          let index = res.data.data.findIndex(item => item.familyRelation === "户主");
          this.huzhulist = JSON.parse(JSON.stringify(res.data.data[index]))
          this.jtlist = JSON.parse(JSON.stringify(res.data.data))
          this.rightshow = true
        })
        // console.log(id, '户主ID')

      },
      // 、农田
      queryFamilyDataNT(id) {
        // this.ntxqshow = 0
        // this.isclickntxq = -1
        this.$http.get(`/api/tLand/get/`, {
          params: {
            id: id
          },
        }).then(res => {
          console.log(res, 'res')
          // ntlistxq
          this.huzhulist = JSON.parse(JSON.stringify(res.data.data))
          // this.ntlist = res.data.data
          this.rightshow = true
        })

      },
      // // 、企业
      queryFamilyDataQY(id) {
        // this.qyxqshow = 0
        this.$http.get(`/api/tCompany/get/`, {
          params: {
            id: id
          },
        }).then(res => {
          console.log(res, 'res')
          this.huzhulist = JSON.parse(JSON.stringify(res.data.data))
          // this.qylist = res.data.data
          this.rightshow = true
        })

      },
      // 测量长度
      mapLong(index, arrindex) {
        this.clclickindex = arrindex
        if (index == 0) {
          this.clclickindex = -1
        } else if (index == -1) {
          this.goback();
          return;
        }
        addEventListener('message', e => {
          console.log(e)
        })
        let that = this
        let datamap = {
          type: "DrawOnMap",  //接口类型 必填
          result: index //  必填 int  //0为清空测量  1为测量长度 2为测量面积
        }
        let mapFrame = this.$refs["mapFrame"]
        that.$refs.mapFrame.contentWindow.postMessage(JSON.stringify(datamap), '*')

      },

      // 十四、男女比列，党组织比列
      getPeopleRate() {
        this.$http.get(`api/gis/peopleRate`).then(res => {
          if (res.data.code == 200) {
            let datajson = [{
              value: [res.data.data.sex.man, res.data.data.sex.woman],
              name: ["男", "女"]
            }]

            this.sexdata = JSON.parse(JSON.stringify(datajson))
          }
        })

      },
      // 十九、大屏-民族占比
      getNationalityRate() {
        this.$http.get(`api/gis/nationalityRate`).then(res => {
          if (res.data.code == 200) {
            let tempArr = []
            res.data.data.countNum.forEach(item => {
              let obj = {
                name: item.nation,
                value: item.nationNum
              }

              tempArr.push(obj)
            })

            this.pieData1 = JSON.parse(JSON.stringify(tempArr))
          }
        })
      },
      // 二十、大屏-网格户数、网格常驻人口、网格党员
      getGridRate() {
        this.$http.get(`api/gis/gridRate`).then(res => {
          if (res.data.code == 200) {
            let tempArr1 = [],
              tempArr2 = [];
            //网格户数
            this.wghsfxlist = JSON.parse(JSON.stringify(res.data.data.gridHousehold))
            // 网格常驻人口
            let renkouData = [{
              name: '常住人口数量',
              type: 'bar',
              stack: 'Total',
              data: []
            }]
            res.data.data.gridPeople.forEach(item => {
              renkouData[0].data.push(item.num)
              tempArr1.push(item.gridName)
            })
            this.renkouData = JSON.parse(JSON.stringify(renkouData))
            this.renkouNames = JSON.parse(JSON.stringify(tempArr1))
            // 二十、网格党员
            let dangyuanData = [{
              name: '网格党员数量',
              type: 'line',
              stack: 'Total',
              data: []
            }]
            res.data.data.gridPartyMember.forEach(item => {
              dangyuanData[0].data.push(item.num)
              tempArr2.push(item.gridName)
            })
            this.dangyuanData = JSON.parse(JSON.stringify(dangyuanData))
            this.dangyuanNames = JSON.parse(JSON.stringify(tempArr2))
          }
        })
      },

      // 移除标签
      removeLabels(val) {
        var index = this.options.findIndex(item => item.value == val);
        this.handleSelect(index)
      },
      // checkbox click事件
      clickCheckbox(e) {
        // console.log(e)
        e.preventDefault()
      },
      // 下拉框点击事件
      handleSelect(index) {
        this.options[index].isCheck = !this.options[index].isCheck
        let checkedCount = this.selectValue.length;
        this.org.checkAllcheckAll = checkedCount === 6 ? true : false;
        this.org.isIndeterminate = checkedCount >= 0 && checkedCount < 6;
        this.initMapInfo()
      },
      // 全选监听
      handleCheckAllChange(value) {
        this.org.isIndeterminate = false
        if (value) {
          this.options.map(p => p.isCheck = true)
          this.selectValue = ['1', '2', '3', '4', '5', '6']
        } else {
          this.options.map(p => p.isCheck = false)
          this.selectValue = []
        }
        this.initMapInfo()
      },
    }
  }
</script>

<style scoped lang="less">
  * {
    color: #FFFFFF;
    scrollbar-color: #0E3680 transparent;
    /* 滑块颜色  滚动条背景颜色 未生效 */
    scrollbar-width: thin;
    /* 滚动条宽度有三种：thin、auto、none */
  }

  .app-container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .frame_page {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .tableft {
      position: absolute;
      text-align: center;
      z-index: 2;
      top: 40%;
      left: 21%;
      cursor: pointer;
      caret-color: transparent;
      width: 1.625rem;
      height: 5.9375rem;
      background: url(../../assets/satistics/map/shouqi.png);

      &.shouqi {
        background: url(../../assets/satistics/map/zhankai.png);
        left: 0%
      }
    }

    .left_pad {
      position: absolute;
      top: 2%;
      left: 1%;
      background: rgba(0, 0, 0, 0.65);
      height: 96%;
      width: 20%;
      padding: 0.6rem 0rem 0.4rem 0rem;
      overflow: hidden;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        // background-color: #454d7d;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb {
        width: 0.3125rem;
        border-radius: 5px;
        background: #0E3680;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }

      .sexbg {
        display: flex;
        height: 50%;
        align-items: center;

        img {
          width: 1.6rem;
          height: 1.6rem;
        }
      }

      .wghsfx {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        box-sizing: border-box;
        height: 100%;

        &::after {
          content: "";
          height: 0;
          width: 30%;
        }

        .wghsitem {
          width: 30%;
          height: 48%;
          padding-bottom: 0.4rem;
          margin: 0.2rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: rgba(1, 4, 4, 0.5);
          font-size: 1rem;
          text-align: center;
          align-items: center;
          box-sizing: border-box;

          .wgfxnum {
            font-size: 1rem;
            text-align: center;
            width: 4.25rem;
            height: 2.375rem;
            line-height: 1.8rem;

            background-image: url(../../assets/satistics/map/wanggefx.png);
            background-size: 100% 100%;

            span {
              font-size: 1.6rem;
              font-weight: bold;
            }
          }

          .wgfxname {
          }
        }
      }
    }

    .gunbi {
      position: absolute;
      right: 3%;
      font-size: 1rem;
      cursor: pointer;
    }

    .right_pad {
      position: absolute;
      top: 2%;
      right: 1%;
      background: rgba(0, 0, 0, 0.65);
      max-height: 88%;
      padding: 0.6rem 0rem 1.5rem 0rem;
      width: 20%;

      .jiatingmsg {
        padding: 0 0.5rem;
        border-bottom: 1px dotted #787878;
        background: rgba(51, 51, 51, 0.5);

        &.xq {
          height: 100%;
          overflow: hidden;
          overflow-y: scroll;
          border-bottom: 0px dotted #787878;

          &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
            // background-color: #454d7d;
            border-radius: 5px;
          }

          &::-webkit-scrollbar-thumb {
            width: 0.3125rem;
            border-radius: 5px;
            background: #0E3680;
          }

          &::-webkit-scrollbar-track {
            background-color: transparent;
          }
        }

        .jtmsgitem {
          display: flex;
          font-size: 1rem;
          padding: 0.4rem 0;
          align-items: center;

          &:nth-child(even) {
            background: rgba(1, 4, 4, 0.5);
          }

          span {
            // height: 36px;
            min-width: 35%;
            max-width: 40%;
            color: rgba(128, 129, 129, 0.8);
            font-size: 1rem;
            text-align: right;
          }

          p {
            width: 60%;

            &.jtcynum {
              width: 45%;
            }
          }

          .checkmsg {
            padding: 0.2rem;
            font-size: 0.875rem;
            background: rgba(1, 4, 4, 0.5);
            border-radius: 2px;
            border: 1px solid #0BACFA;
            cursor: pointer;
            color: #0BACFA;
          }
        }
      }

      .jtrenyuan {
        height: 100%;

        .jtcytitle {
          font-size: 1.2rem;
          font-weight: 400;
          padding: 0.4rem 0;
        }

        .jtcylist {
          overflow: hidden;
          overflow-y: scroll;
          max-height: 62vh;

          &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
            // background-color: #454d7d;
            border-radius: 5px;
          }

          &::-webkit-scrollbar-thumb {
            width: 0.3125rem;
            border-radius: 5px;
            background: #0E3680;
          }

          &::-webkit-scrollbar-track {
            background-color: transparent;
          }

          .jtcyitem {
            display: flex;
            padding: 0.3rem 0.4rem;
            background: rgba(0, 0, 0, 0.65);
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.4rem;
            border: 2px solid rgba(0, 0, 0, 0.65);
            cursor: pointer;

            &.isclck,
            &:hover {
              background: rgba(1, 4, 4, 0.5);
              border-radius: 2px;
              border: 2px solid #B26C04;
            }

            .itemleft {
              width: 90%;

              .jtcyitemname {
                color: #0BACFA;
                font-weight: bold;
                font-size: 1rem;
                padding: 0.2rem 0rem;

                span {
                  background: #94701C;
                  border-radius: 2px;
                  font-weight: normal;
                  padding: 0.1rem 0.2rem;
                  margin-left: 0.4rem;

                }
              }

              .jtitemqita {
                padding: 0.2rem 0rem;
                display: flex;
                justify-content: center;

                span {
                  font-size: 1rem;
                  width: 20%;

                  &:nth-child(2) {
                    text-align: center;
                  }

                  &:last-child {
                    width: 58%;
                    border-right: 0px solid #FFFFFF;
                    padding-left: 0.8rem;
                  }
                }
              }
            }

            .itemright {
              width: 2rem;
              height: 2rem;
              border-radius: 1rem;
              border: 0px solid #6D6D6D;
              color: rgba(91, 91, 93, 1);
              background-color: #262627;
              text-align: center;
              line-height: 2rem;
              font-size: 1rem;

              &.isclck {
                border: 1px dotted #6D6D6D;
                border-radius: 0.1rem;
              }
            }
          }
        }
      }

      .jtcylistxq {
        .jtxqtitle {
          font-size: 1.2rem;
          font-weight: 400;
          padding: 0.4rem 0;
          // color: #0BACFA;
          cursor: pointer;

          i {
            // color:#0BACFA ;
          }
        }
      }

    }
  }

  .back_button {
    position: absolute;
    right: 2rem;
    bottom: 0.8rem;
    width: 4.375rem;
    z-index: 500;
    /*background: red;*/
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    .map_icon {
      width: 100%;

    }

    .map_text {
      flex: 1;
      font-size: 20px;
      margin: 0 6px;
      color: #fff;
    }

    .map_icon_right {
      width: 15%;
    }
  }

  .celiangbtn {
    position: absolute;
    right: 1rem;
    // bottom: 5rem;
    bottom: 1rem;
    z-index: 500;
    /*background: red;*/
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    img {
      width: 2rem;
    }
  }

  .choosebg {
    width: 12.5rem;
    display: flex;
    position: absolute;
    top: 1.2rem;
    left: 20.5%;
    z-index: 1000;
    align-items: center;

    &.left {
      left: 0;
    }

    ::v-deep {

      // .el-select{
      // 	width: 12.5rem;
      // }
      .el-input__suffix {
        display: flex;
        align-items: center;
      }

      .el-input__prefix {
        display: none;
      }

      .el-input__inner {
        background: rgba(25, 33, 43, 0.7);
        border-color: rgba(47, 106, 132, 1);
        width: 7rem;
        cursor: pointer;
        padding: 4px 12px;
        border-radius: 2px;
        height: 50px;
        color: #5B6F84;
        width: 100%;
      }

      .el-select-dropdown.is-multiple .el-select-dropdown__item.selected,
      .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
        background: rgba(25, 77, 164, 1);
      }

      .el-checkbox__input.is-checked {
      }

    }
  }

  // .rygj_radio>label{
  // 	background-color: #FFFFFF;
  // }
  // .el-radio{
  // 	margin-right: 0;
  // }
  // 	/deep/ .el-radio__label{
  // 			padding-left: 0 !important;
  // 			font-size: 14px;
  // 		}
  /deep/ .el-checkbox__input > .el-checkbox__inner {
    background: rgba(25, 77, 164, 1);
    border-color: rgba(31, 58, 83, 0.8);
  }

  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: rgba(0, 140, 209, 1) !important;
    border: 1px solid rgba(37, 161, 207, 1) !important;
  }

  /deep/ .el-checkbox__inner:hover {
    border-color: rgba(0, 140, 209, 1);
  }

  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: rgba(0,140,209,1);
  }

  /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: rgba(0, 140, 209, 1) !important;
  }

  // /deep/ .el-input__inner {
  //   // background: none !important;
  //   color: #00FDFF;
  //   width: 8.3rem;
  //   height: 1.8rem;
  //   line-height: 1.8rem;
  //   border: 1px solid #587CA0;
  // }

  /deep/ .el-input__icon {
    line-height: 1.8rem;
  }

  /deep/ .el-select-dropdown {
    background: rgba(25, 33, 43, 0.7);
    border: 1px solid #1060A8;
    z-index: 200;
  }

  /deep/ .el-input__prefix,
  /deep/ .el-input__suffix {
    color: #587CA0;
  }


  /deep/ .el-select-dropdown,
  /deep/ .el-popper[x-placement^=bottom] .popper__arrow {
    background: rgba(25, 33, 43, 0.7);
    border: 1px solid #1060A8;
    z-index: 200;
  }

  /deep/ .el-input__prefix,
  /deep/ .el-input__suffix {
    color: #587CA0;
  }

  /*// select选择器*/
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(68, 122, 203, 0.87);
  }

  /deep/ .el-popper[x-placement^=bottom] .popper__arrow:after {
    border-bottom-color: rgba(25, 33, 43, 0.7);

  }


  /deep/ .el-select-dropdown__item.selected {
    color: #00FDFF;
  }

  /deep/ .el-select-dropdown__item {
    color: #5B6F84;

    img {
      vertical-align: middle;
    }
  }

  /deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    display: none;
  }
  /deep/ .el-select-dropdown__item{
    font-size: 16px;
  }
  /deep/ .el-tag--small{
    height: 40px;
  }
  /deep/ .el-checkbox__label{
    font-size: 16px;
  }
</style>
